/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { SupplierAttributeValue } from './SupplierAttributeValue'
import {
  SupplierAttributeValueFromJSON,
  SupplierAttributeValueFromJSONTyped,
  SupplierAttributeValueToJSON,
  SupplierAttributeValueToJSONTyped,
} from './SupplierAttributeValue'

/**
 *
 * @export
 * @interface SupplierAttribute
 */
export interface SupplierAttribute {
  /**
   *
   * @type {string}
   * @memberof SupplierAttribute
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof SupplierAttribute
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof SupplierAttribute
   */
  valueType: SupplierAttributeValueTypeEnum
  /**
   *
   * @type {boolean}
   * @memberof SupplierAttribute
   */
  isRequired: boolean
  /**
   *
   * @type {number}
   * @memberof SupplierAttribute
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof SupplierAttribute
   */
  updatedAt: number
  /**
   *
   * @type {SupplierAttributeValue}
   * @memberof SupplierAttribute
   */
  value?: SupplierAttributeValue
}

/**
 * @export
 */
export const SupplierAttributeValueTypeEnum = {
  String: 'STRING',
  Number: 'NUMBER',
  Boolean: 'BOOLEAN',
  Date: 'DATE',
  Time: 'TIME',
  Datetime: 'DATETIME',
  List: 'LIST',
  Object: 'OBJECT',
  None: 'NONE',
} as const
export type SupplierAttributeValueTypeEnum =
  (typeof SupplierAttributeValueTypeEnum)[keyof typeof SupplierAttributeValueTypeEnum]

/**
 * Check if a given object implements the SupplierAttribute interface.
 */
export function instanceOfSupplierAttribute(
  value: object,
): value is SupplierAttribute {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('valueType' in value) || value['valueType'] === undefined) return false
  if (!('isRequired' in value) || value['isRequired'] === undefined)
    return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function SupplierAttributeFromJSON(json: any): SupplierAttribute {
  return SupplierAttributeFromJSONTyped(json, false)
}

export function SupplierAttributeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SupplierAttribute {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    valueType: json['valueType'],
    isRequired: json['isRequired'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
    value:
      json['value'] == null
        ? undefined
        : SupplierAttributeValueFromJSON(json['value']),
  }
}

export function SupplierAttributeToJSON(json: any): SupplierAttribute {
  return SupplierAttributeToJSONTyped(json, false)
}

export function SupplierAttributeToJSONTyped(
  value?: SupplierAttribute | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    name: value['name'],
    valueType: value['valueType'],
    isRequired: value['isRequired'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
    value: SupplierAttributeValueToJSON(value['value']),
  }
}
